export function ConstructClassWithPrivateMembers(instance, symbol) {
    Object.defineProperty(instance, symbol, {
        value: {},
        configurable: false,
        writable: false,
        enumerable: false,
    });
}
export const PROTECTED = Symbol('protected');
export function ConstructClassWithProtectedMembers(instance) {
    Object.defineProperty(instance, PROTECTED, {
        value: {},
        configurable: false,
        writable: false,
        enumerable: false,
    });
}
//# sourceMappingURL=ClassWithPrivateMembers.js.map